const signUpForm = $("#SignUpForm");
const domainNameRegexPattern = "^[a-zA-Z0-9]*$";

$.validator.setDefaults({ ignore: '' });
$.validator.addMethod(
    "regex",
    function (value, element, regexPattern) {
        if (!value || !value.length) {
            return true;
        }
        let regex = new RegExp(regexPattern);
        return regex.test(value);
    },
    "No spaces or special characters allowed"
);

$.validator.addMethod(
    "domainNameExists",
    function (value, element) {
        if (!value || !value.length) {
            return true;
        }

        let isSuccess = true;
        let regex = new RegExp(domainNameRegexPattern);

        if (regex.test(value)) {
            $.ajax({
                url: "/api/validation/domain",
                type: "GET",
                data: { name: value },
                async: false,
                success: function (response) {
                    isSuccess = response;
                }
            });
        }
        
        return isSuccess;
    },
    "Domain name is not available"
);

signUpForm.validate({
    errorElement: "div",
    errorPlacement: function (error, element) {
        element.siblings("span.field-error").append(error);
    },
    highlight: function (element) {
        $(element).closest(".form-row").removeClass("has-error").addClass("has-error");
    },
    unhighlight: function (element) {
        $(element).closest(".form-row").removeClass("has-error");
    },
    rules: {
        "EmailAddress": {
            required: true,
            email: true
        },
        "FirstName": {
            required: true
        },
        "LastName": {
            required: true
        },
        "CompanyName": {
            required: true
        },
        "Subdomain": {
            required: true,
            domainNameExists: true,
            regex: domainNameRegexPattern
        },
        "AgreeTerms": {
            required: true
        }
    },
    messages: {
        "EmailAddress": {
            required: "Email Address is required",
            email: "Enter a valid email address"
        },
        "FirstName": {
            required: "First Name is required",
        },
        "LastName": {
            required: "Last Name is required",
        },
        "CompanyName": {
            required: "Company Name is required",
        },
        "Subdomain": {
            required: "Domain Name is required",
            domainNameExists: "Domain Name is not available.",
        },
        "AgreeTerms": {
            required: "Please accept terms & conditions"
        }
    },
    onkeyup: false,
    onfocusout: function (element) {
        if (element.id === "CompanyName") {
            $("#Subdomain").valid();
        }
        $(element).valid();
    },
    showErrors: function (errorMap, errorList) {
        this.defaultShowErrors();
        var summaryDiv = signUpForm.find("div.validation-summary"),
            container = summaryDiv.find("[data-valmsg-summary=true]"),
            list = container.find("ul");
        var errorElements = signUpForm.find(".error")
            .filter((index, element) => element.innerHTML);
        if (errorElements.length) {
            list.empty();
            container.addClass("validation-summary-errors").removeClass("validation-summary-valid");
            $.each(errorElements, function (index, element) {                
                $(element).css("display", "none");
                $("<li />").html(element.innerHTML).appendTo(list);
            });
            summaryDiv.show();
        } else {
            container.addClass("validation-summary-valid").removeClass("validation-summary-errors");
            summaryDiv.hide();
        }
    }
});